import React from "react";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { ArrowRightIcon } from "../../../../../../../../assets/Icons/ArrowRightIcon";
import { useContext } from "../../../../context";
import styles from "./styles.module.scss";

export const Title = () => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey.preview",
  });

  const { title } = useContext();

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <span>{t("title")}</span>
        <ArrowRightIcon width="16px" />
      </div>
      {title.value}
    </div>
  );
};
